import { SITE_URL } from 'env';

type Theme = 'light' | 'dark';

const THEME_ICONS = {
  light: `${SITE_URL}images/icons/sun.svg`,
  dark: `${SITE_URL}images/icons/moon.svg`,
};

const checkSwitcherItem = (switcherMenuItemEls: NodeListOf<HTMLDivElement>) => {
  const currentTheme = document.body.dataset.mdColorScheme as Theme;

  switcherMenuItemEls.forEach((el) => {
    const { itemValue } = el.dataset;

    if (itemValue === currentTheme) {
      el.classList.add('checked');
    } else {
      el.classList.remove('checked');
    }
  });
};

export const initThemeSwitcherMobile = () => {
  const themeSwitcherEl = document.querySelector(
    '.theme-switcher-mobile'
  ) as HTMLDivElement;

  if (!themeSwitcherEl) {
    return;
  }

  const sidebarInnerEl = document.querySelector(
    '.md-sidebar--primary .md-nav--primary'
  ) as HTMLDivElement;

  sidebarInnerEl.prepend(themeSwitcherEl);

  const themeSwitcherEls = document.querySelectorAll(
    '.theme-switcher-mobile'
  ) as NodeListOf<HTMLDivElement>;

  themeSwitcherEls.forEach((el) => {
    const themeSwitcherValueEl = el.querySelector(
      '.switcher .switcher-value'
    ) as HTMLSpanElement;
    const themeSwitcherImgEl = el.querySelector(
      '.switcher img'
    ) as HTMLImageElement;

    const currentTheme = document.body.dataset.mdColorScheme as Theme;

    themeSwitcherValueEl.textContent = currentTheme;
    themeSwitcherImgEl.src = THEME_ICONS[currentTheme];

    const switcherEl = el.querySelector('.switcher') as HTMLDivElement;

    switcherEl.addEventListener('click', () => {
      switcherEl.classList.toggle('active');
    });

    const switcherMenuItemEls = switcherEl.querySelectorAll(
      '.switcher-menu-item'
    ) as NodeListOf<HTMLDivElement>;

    checkSwitcherItem(switcherMenuItemEls);

    switcherMenuItemEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();

        const { itemValue = '' } = el.dataset;

        const mainThemeToggleEl = document.querySelector(
          `.md-option[data-md-color-scheme="${itemValue}"]`
        ) as HTMLDivElement;

        themeSwitcherValueEl.textContent = itemValue;
        mainThemeToggleEl.click();
        checkSwitcherItem(switcherMenuItemEls);
        switcherEl.classList.remove('active');
      });
    });
  });
};
